import axios from "axios";
import AbstractPathService from "./AbstractPathService";

// const dateFormat = "YYYYMMDDT000000";

class PathService extends AbstractPathService {
  getItemPaths(itemid, start, end) {
    // const startDate = moment(start).format(dateFormat);
    // const endDate = moment(end).format(dateFormat);
    return axios
      .get("/sitecore/shell/client/Applications/altola/insights/data/paths.json")
      .then(res => res.data)
      .catch(error => {});
  }
}

export default new PathService();



// WEBPACK FOOTER //
// ./src/data/PathService.dev.js